import React from 'react';
import { FaLinkedin, FaInstagram, FaYoutube, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-blue-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <img
              src="/images/fvlinkinllplogo.png"
              alt="Vlinkin Professionals"
              className="h-24 mb-4"
            /> 
            
            <p className="text-gray-400 mb-4">
              Empower your career with our top-notch training programs. Building the workforce of tomorrow.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/in/vlinkin-professionals-llp-a0aaa32a4"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-500 transition-colors"
                data-testid="footer-linkedin"
              >
                <FaLinkedin size={24} />
              </a>
              <a
                href="https://www.instagram.com/linkinprofessionals"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-500 transition-colors"
                data-testid="footer-instagram"
              >
                <FaInstagram size={24} />
              </a>
              <a
                href="https://www.youtube.com/@linkinprofessionals"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-red-500 transition-colors"
                data-testid="footer-youtube"
              >
                <FaYoutube size={24} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('programs')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Our Programs
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Bangalore */}
          <div>
            <h3 className="text-lg font-bold mb-4">Bangalore Office</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start gap-2">
                <FaMapMarkerAlt className="mt-1 flex-shrink-0" />
                <span className="text-sm">#30, 2nd Floor, Raghuvanhalli, Kanakpura Main Road, Bengaluru 560062</span>
              </li>
              <li className="flex items-center gap-2">
                <FaPhone className="flex-shrink-0" />
                <a href="tel:+918971504452" className="hover:text-white transition-colors">
                  +91 8971504452
        
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Mysore */}
          <div>
            <h3 className="text-lg font-bold mb-4">Mysore Office</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start gap-2">
                <FaMapMarkerAlt className="mt-1 flex-shrink-0" />
                <span className="text-sm">#5490, Dr Mh Ambareesha Road, Water Tank Circle, Mysore 570017</span>
              </li>
              <li className="flex items-center gap-2">
                <FaPhone className="flex-shrink-0" />
                <a href="tel:+918971504452" className="hover:text-white transition-colors">
                  +91 8971504452
        
                </a>
                
              </li>
              <li className="flex items-center gap-2">
                <FaPhone className="flex-shrink-0" />
                <a href="tel:+918971504452" className="hover:text-white transition-colors">
                  +91 8971703730
        
                </a>
                
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} VLINKIN PROFESSIONALS LLP. ALL RIGHTS RESERVED.
            </p>
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <FaEnvelope />
              <a
                href="mailto:info@linkinprofessionals.com"
                className="hover:text-white transition-colors"
              >
                info@linkinprofessionals.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;